/**
 * 生成scream人数或阅读量字符串
 */
export const getScreamNumber = (count: number): string => {
  if (count > 1000) {
    if (count < 1000000) {
      if (count % 1000 === 0) {
        return `${Math.floor(count / 1000)}k`
      } else {
        return `${Math.floor(count / 1000)}k+`
      }
    }
    if (count < 1000000000) {
      if (count % 1000000 === 0) {
        return `${Math.floor(count / 1000000)}m`
      } else {
        return `${Math.floor(count / 1000000)}m+`
      }
    }
    return `999m+`
  }
  return `${count}`
}
